const $ = jQuery;

const Faq = {
  init: function () {
    $(".question").on("click", (e) => {
      const parent = $(e.target).closest(".section-faq--items-item");
      const content = parent.find(".answer");
      const activeItem = $(".section-faq--items-item.active");

      if (!parent.hasClass("active")) {
        if (activeItem.length > 0) {
          const activeContent = activeItem.find(".answer");
          activeContent.slideUp();
          activeItem.removeClass("active");
        }

        content.slideDown();
        parent.addClass("active");
      } else {
        content.slideUp();
        parent.removeClass("active");
      }
    });
  },
};

export default Faq;
